<div layout layout-align-items-center>
  @if (scope().isAccountVerified) {
    @if (context() === 'redactor') {
      <rt-button size="small" margin-lr-small-x>
        <ng-container *ngTemplateOutlet="content" />
      </rt-button>
    } @else {
      <rt-button size="small" [variant]="buttonVariant()">
        <ng-container *ngTemplateOutlet="content" />
      </rt-button>
    }
  }
</div>

<ng-template #content>
  <rt-badge color="ai" [text]="'app.common.ai' | translate" margin-right-small-x />
  <span>{{ 'app.offer_form.create_with_ai' | translate }}</span>
</ng-template>
